import { isEmpty } from '@/common/methods';

const validateAddProduct = (data) => {
  const inputErrors = {};

  data.name = !isEmpty(data.name) ? data.name : '';
  data.description = !isEmpty(data.description) ? data.description : '';

  if (isEmpty(data.name)) {
    inputErrors.name = 'Product name is required';
  }

  if (isEmpty(data.code)) {
    inputErrors.code = 'Product code is required';
  }

  if (isEmpty(data.description)) {
    inputErrors.description = 'Product description is required';
  }

  return {
    inputErrors,
    isValid: isEmpty(inputErrors),
  };
};

export default validateAddProduct;
